"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_day_picker_1 = __importDefault(require("react-day-picker"));
require("react-day-picker/lib/style.css");
var date_range_picker_styles_1 = require("./date-range-picker.styles");
var date_range_picker_containers_styles_1 = require("./date-range-picker-containers.styles");
var date_range_picker_header_component_1 = __importDefault(require("./date-range-picker-header.component"));
var date_range_picker_footer_component_1 = __importDefault(require("./date-range-picker-footer.component"));
var date_range_picker_ranges_component_1 = __importDefault(require("./date-range-picker-ranges.component"));
var date_range_picker_hook_1 = __importDefault(require("./date-range-picker.hook"));
var date_range_localization_hook_1 = __importDefault(require("./date-range-localization.hook"));
function setRanges(from, to) {
    return {
        startRange: from,
        endRange: to,
    };
}
var DateRangePicker = function (_a) {
    var _b = _a.numberOfMonths, numberOfMonths = _b === void 0 ? 2 : _b, _c = _a.isEnabled, isEnabled = _c === void 0 ? true : _c, selectedDays = _a.selectedDays, onApply = _a.onApply, className = _a.className;
    var _d = react_1.useState(false), isOpen = _d[0], setIsOpen = _d[1];
    var _e = react_1.useState('from'), inFocus = _e[0], setInFocus = _e[1];
    var _f = react_1.useState(false), mouseIsOver = _f[0], setMouseIsOver = _f[1];
    var _g = react_1.useState(selectedDays), localSelectedDays = _g[0], setLocalSelectedDays = _g[1];
    var from = localSelectedDays.from, to = localSelectedDays.to;
    var _h = date_range_localization_hook_1.default(), weekdays = _h[0], months = _h[1];
    var _j = date_range_picker_hook_1.default({
        isOpen: isOpen,
        setIsOpen: setIsOpen,
        inFocus: inFocus,
        setInFocus: setInFocus,
        localSelectedDays: localSelectedDays,
        selectedDays: selectedDays,
        from: from,
        to: to,
        setLocalSelectedDays: setLocalSelectedDays,
        onApply: onApply,
    }), handleDayClick = _j[0], toggle = _j[1], onChange = _j[2], apply = _j[3], cancel = _j[4];
    react_1.useEffect(function () {
        setLocalSelectedDays(selectedDays);
    }, [selectedDays]);
    react_1.useEffect(function () {
        var handler = function () {
            if (!mouseIsOver && isOpen)
                cancel();
        };
        document.addEventListener('click', handler);
        return function () { return document.removeEventListener('click', handler); };
    }, [mouseIsOver, isOpen, selectedDays, cancel]);
    var modifiers = setRanges(from, to);
    return (react_1.default.createElement(date_range_picker_styles_1.Outer, { className: className, onMouseEnter: function () { return setMouseIsOver(true); }, onMouseLeave: function () { return setMouseIsOver(false); } },
        react_1.default.createElement(date_range_picker_header_component_1.default, { isOpen: isOpen, setIsOpen: setIsOpen, inFocus: inFocus, setInFocus: setInFocus, selectedDays: localSelectedDays, toggle: toggle, isEnabled: isEnabled }),
        isOpen && (react_1.default.createElement(date_range_picker_containers_styles_1.DayPickerContainer, null,
            react_1.default.createElement(date_range_picker_styles_1.LeftColumn, null,
                react_1.default.createElement(react_day_picker_1.default, { fixedWeeks: true, weekdaysShort: weekdays, month: from, months: months, onDayClick: handleDayClick, firstDayOfWeek: 1, numberOfMonths: numberOfMonths, modifiers: modifiers, selectedDays: localSelectedDays })),
            react_1.default.createElement(date_range_picker_styles_1.RightColumn, null,
                react_1.default.createElement(date_range_picker_ranges_component_1.default, { onChange: onChange })),
            react_1.default.createElement(date_range_picker_footer_component_1.default, { isEnabled: isEnabled, apply: apply, cancel: cancel })))));
};
DateRangePicker.displayName = 'DateRangePicker';
exports.default = DateRangePicker;
//# sourceMappingURL=date-range-picker.component.js.map